import { BalanceContainer } from "Components/Dashboard/BalanceWithPaymentActions/BalanceContainer";
import { DesktopBalanceHeader } from "Components/Dashboard/BalanceWithPaymentActions/DesktopBalance/Components/DesktopBalanceHeader";
import { DesktopBalanceSkeleton } from "Components/Dashboard/BalanceWithPaymentActions/DesktopBalance/Components/DesktopBalanceSkeleton";
import { DesktopCurrencyBalance } from "Components/Dashboard/BalanceWithPaymentActions/DesktopBalance/Components/DesktopCurrencyBalance";
import { PaymentActions } from "Components/Dashboard/BalanceWithPaymentActions/DesktopBalance/Components/PaymentActions";
import { CommonError } from "Components/Shared/Errors/CommonError";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";

// Module-level so the error view keeps its identity across re-renders of the paper.
const DesktopBalanceError = () => <CommonError withoutPaper />;

export const DesktopBalance = () => (
  <PrimaryPaper>
    <BalanceContainer
      renderHeader={DesktopBalanceHeader}
      renderBalances={DesktopCurrencyBalance}
      renderActions={PaymentActions}
      renderLoading={DesktopBalanceSkeleton}
      renderError={DesktopBalanceError}
    />
  </PrimaryPaper>
);
